import '@fontsource/roboto'
// import Flickity from './vendors/flickity/flickity.pkgd.min';

console.log('Hello from the child theme!')

var elems = document.querySelectorAll('#index .featured-products .products');

elems.forEach(function (elem) {
  new Flickity(elem, {
    cellAlign: 'left',
    wrapAround: true,
    pageDots: true
  });
});

// Bouton "Filtrer" pour ouvrir les filtres en version mobile
var filtersToggler = document.querySelector('.category-tree-toggler');
var categoryTree = document.getElementById('category-tree');

if (typeof(filtersToggler) != 'undefined' && filtersToggler != null) {
  filtersToggler.addEventListener('click', () => {
    const isActive = filtersToggler.classList.contains('active');

    // Ouvrir celui cliqué
    if (!isActive) {
      filtersToggler.classList.add('active');
      filtersToggler.setAttribute('aria-expanded', 'true');
      categoryTree.classList.add('block-categories--opened')
    } else {
      filtersToggler.classList.remove('active');
      filtersToggler.setAttribute('aria-expanded', 'false');
      categoryTree.classList.remove('block-categories--opened')
    }
  });
}
